var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobPost4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 30,
    viewBox: "0 0 25 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8333 0H4.16667C1.86875 0 0 1.68187 0 3.75V22.5C0 22.8319 0.145833 23.1488 0.406249 23.3831L7.35 29.6325C7.6125 29.8688 7.96458 30 8.33333 30H20.8333C23.1312 30 25 28.3181 25 26.25V3.75C25 1.68187 23.1312 0 20.8333 0ZM22.2229 26.25C22.2229 26.94 21.6 27.5006 20.8333 27.5006H9.72292V24.6881C9.72292 22.7925 8.01042 21.2512 5.90417 21.2512H2.77917V3.75C2.77917 3.06 3.40208 2.49938 4.16875 2.49938H20.8354C21.6021 2.49938 22.225 3.06 22.225 3.75L22.2229 26.25Z",
    fill: "#FFC327"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5494 9.99988H8.45058C7.10034 9.99988 6 9.0194 6 7.81208V7.1878C6 5.98235 7.09824 5 8.45058 5H17.5494C18.8997 5 20 5.98048 20 7.1878V7.81208C19.9979 9.0194 18.8997 9.99988 17.5494 9.99988Z",
    fill: "#FFC327"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5994 15H7.40063C6.62787 15 6 14.3276 6 13.5C6 12.6724 6.62787 12 7.40063 12H18.5994C19.3721 12 20 12.6724 20 13.5C20 14.3276 19.3721 15 18.5994 15Z",
    fill: "#FFC327"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5994 20H7.40063C6.62787 20 6 19.3276 6 18.5C6 17.6724 6.62787 17 7.40063 17H18.5994C19.3721 17 20 17.6724 20 18.5C20 19.3276 19.3721 20 18.5994 20Z",
    fill: "#FFC327"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobPost4);
export default __webpack_public_path__ + "static/media/job-post4.025c2f131f05dea82c8e4c761f6e6ab9.svg";
export { ForwardRef as ReactComponent };